import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import RoleList from './RoleList/RoleList';
import AddEditRole from './AddEditRole/AddEditRole';
import PermissionList from './PermissionList/PermissionList';
import AddEditPermission from './AddEditPermission/AddEditPermission';
import AssignPermissions from './AssignPermissions/AssignPermissions';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

const Permissions = () => {
  const location = useLocation();
  const { updateBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();

  React.useEffect(() => {
    let currentLabel = 'Roles';
    if (location.pathname.includes('/permissions/add')) currentLabel = 'Add Permission';
    else if (location.pathname.includes('/permissions/edit/')) currentLabel = 'Edit Permission';
    else if (location.pathname.includes('/permissions')) currentLabel = 'Permissions';
    else if (location.pathname.includes('/roles/add')) currentLabel = 'Add Role';
    else if (location.pathname.includes('/roles/edit/')) currentLabel = 'Edit Role';
    else if (location.pathname.includes('/roles/') && location.pathname.includes('/assign')) currentLabel = 'Assign Permissions';

    updateBreadcrumbs([
      { label: 'Permission', path: '/permission/roles' },
      { label: currentLabel, path: null, active: true }
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, [location.pathname, updateBreadcrumbs, clearBreadcrumbs]);

  return (
    <Routes>
      <Route path="roles" element={<RoleList />} />
      <Route path="roles/add" element={<AddEditRole />} />
      <Route path="roles/edit/:roleId" element={<AddEditRole />} />
      <Route path="roles/:roleId/assign" element={<AssignPermissions />} />
      <Route path="permissions" element={<PermissionList />} />
      <Route path="permissions/add" element={<AddEditPermission />} />
      <Route path="permissions/edit/:permissionId" element={<AddEditPermission />} />
      <Route path="" element={<Navigate to="/permission/roles" replace />} />
    </Routes>
  );
};

export default Permissions;

